module.exports = __webpack_public_path__ + "img/01.bb2fb12c.png";